module.exports = __webpack_public_path__ + "img/add-image14.56759933.png";